// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TasksBank__View[data-v-774cc120] {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
